import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Vérifier si l'utilisateur est connecté
  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    return !!(token && user);
  };

  if (!isAuthenticated()) {
    // Rediriger vers la page de login si non authentifié
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;